import { render, staticRenderFns } from "./workerCost.vue?vue&type=template&id=5d4764bc&scoped=true&"
import script from "./workerCost.vue?vue&type=script&lang=js&"
export * from "./workerCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4764bc",
  null
  
)

export default component.exports